import React from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default () => {
  const history = useHistory();
  const location = useLocation();
  return (
    <footer className="bg-gradient-to-br from-slate-800 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">B</span>
              </div>
              <span className="text-xl font-bold abc-semibold">BiodataMaker</span>
            </div>
            <p className="text-gray-300 mb-6 max-w-md abc-regular leading-relaxed">
              Step into our online biodata maker with open arms! 🌟
              We're excited to guide you through the process of crafting your
              biodata. As a dedicated team, we're committed to
              making this experience not only simple but also enjoyable for you.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-white mb-4 abc-semibold">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="#templates" className="text-gray-300 hover:text-pink-400 transition-colors duration-300 abc-regular">
                  Templates
                </a>
              </li>
              <li>
                <a href="#why-choose-us" className="text-gray-300 hover:text-pink-400 transition-colors duration-300 abc-regular">
                  Features
                </a>
              </li>
              <li>
                <a href="#faq-section" className="text-gray-300 hover:text-pink-400 transition-colors duration-300 abc-regular">
                  FAQ
                </a>
              </li>
              <li>
                <button
                  onClick={() => history.push("/contact-us")}
                  className="text-gray-300 hover:text-pink-400 transition-colors duration-300 abc-regular"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-white mb-4 abc-semibold">Legal</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => history.push("/privacy-policy")}
                  className="text-gray-300 hover:text-pink-400 transition-colors duration-300 abc-regular"
                >
                  Privacy Policy
                </button>
              </li>
              <li>
                <button
                  onClick={() => history.push("/terms-of-service")}
                  className="text-gray-300 hover:text-pink-400 transition-colors duration-300 abc-regular"
                >
                  Terms of Service
                </button>
              </li>
              <li>
                <button
                  onClick={() => history.push("/refund-policy")}
                  className="text-gray-300 hover:text-pink-400 transition-colors duration-300 abc-regular"
                >
                  Refund Policy
                </button>
              </li>
              <li>
                <button
                  onClick={() => history.push("/shipping-policy")}
                  className="text-gray-300 hover:text-pink-400 transition-colors duration-300 abc-regular"
                >
                  Shipping Policy
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm abc-regular mb-4 md:mb-0">
              © 2024 BiodataMaker. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <span className="abc-regular">Made with ❤️ in India</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
